import { DiscountsApi, DiscountCodeCheckRequest, DiscountCodeCheckResponse } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';

interface DiscountValidationCall extends ApiCallBase {
  response: DiscountCodeCheckResponse;
}

interface State {
  discountValidation: DiscountValidationCall;
}

const initialState: State = {
  discountValidation: initialApiState,
};

export const validateDiscountCode = createAsyncThunk(
  'discounts/validateDiscountCode',
  async (discountCode: string) => {
    try {
      const discountsApi = new DiscountsApi(createApiConfiguration());
      
      const request: DiscountCodeCheckRequest = {
        code: discountCode
      };
      
      const response = await discountsApi.discountCheck(request);
      return response.data;
    } catch (error) {
      console.error('Error validating discount code:', error);
      throw error;
    }
  }
);

const DiscountsSlice = createSlice({
  name: 'discounts',
  initialState,
  reducers: {
    resetDiscountValidation: (state) => {
      state.discountValidation = {
        ...initialApiState,
        response: state.discountValidation.response,
      };
    },
    resetDiscountValidationResponse: (state) => {
      state.discountValidation = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(validateDiscountCode.pending, (state) => {
      state.discountValidation.loading = 'pending';
    });
    builder.addCase(validateDiscountCode.fulfilled, (state, action) => {
      state.discountValidation.loading = 'succeeded';
      state.discountValidation.response = action.payload;
    });
    builder.addCase(validateDiscountCode.rejected, (state, action) => {
      state.discountValidation.loading = 'failed';
      state.discountValidation.error = action.payload;
    });
  },
});

export const {
  resetDiscountValidation,
  resetDiscountValidationResponse,
} = DiscountsSlice.actions;

export default DiscountsSlice.reducer; 